/**
 * acq-direct-checkout.js
 * Direct-to-checkout flow for acquisition pages.
 *
 * Features:
 * - Clears existing cart before adding new items
 * - Applies discount codes via checkout URL parameter
 * - Supports single or multiple variants (Buy Both)
 * - Supports Skio subscription selling plans
 * - Bypasses GoCart entirely
 *
 * Data attributes:
 * - data-acq-direct-checkout: Marks button for direct checkout
 * - data-acq-variant-id: Single variant ID to add
 * - data-acq-variant-ids: Comma-separated variant IDs (for Buy Both)
 * - data-acq-quantity: Quantity per item (default: 1)
 * - data-acq-discount-code: Optional discount code to apply
 */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-acq-direct-checkout]').forEach(function (btn) {
      if (btn.hasAttribute('data-acq-dc-bound')) return;
      btn.setAttribute('data-acq-dc-bound', '');
      btn.addEventListener('click', handleClick);
    });
  }

  function handleClick(e) {
    e.preventDefault();
    var btn = e.currentTarget;

    // Prevent double-clicks
    if (btn.disabled) return;

    var singleVariantId = btn.getAttribute('data-acq-variant-id');
    var multipleVariantIds = btn.getAttribute('data-acq-variant-ids');
    var quantity = parseInt(btn.getAttribute('data-acq-quantity') || '1', 10);
    var discountCode = btn.getAttribute('data-acq-discount-code') || '';

    // Build items array
    var items = [];

    if (multipleVariantIds) {
      // Buy Both / multiple items
      var ids = multipleVariantIds.split(',').map(function(id) {
        return parseInt(id.trim(), 10);
      }).filter(function(id) {
        return !isNaN(id);
      });

      ids.forEach(function(id) {
        items.push({ id: id, quantity: quantity });
      });
    } else if (singleVariantId) {
      // Single item
      items.push({
        id: parseInt(singleVariantId, 10),
        quantity: quantity
      });
    }

    if (items.length === 0) {
      console.error('[acq-direct-checkout] No variant IDs found');
      return;
    }

    // If button is inside a <form>, read selling_plan hidden input (Skio compatibility)
    var form = btn.closest('form');
    if (form && items.length === 1) {
      var sellingPlanInput = form.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput && sellingPlanInput.value) {
        items[0].selling_plan = sellingPlanInput.value;
      }
    }

    // Loading state
    var originalText = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Processing…';

    // Step 1: Clear cart
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function () {
        // Step 2: Add item(s) to cart
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || data.message || 'Could not add item to cart');
          });
        }

        // Step 3: Redirect to checkout with discount code if provided
        var checkoutUrl = '/checkout';
        if (discountCode) {
          checkoutUrl += '?discount=' + encodeURIComponent(discountCode);
        }
        window.location.href = checkoutUrl;
      })
      .catch(function (err) {
        // Restore button state
        btn.disabled = false;
        btn.innerHTML = originalText;
        console.error('[acq-direct-checkout] Error:', err);
        alert(err.message || 'Something went wrong. Please try again.');
      });
  }

  // Run on DOMContentLoaded and also immediately (for deferred scripts)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
